/**
 * 首页关于我们组件
 */

import { Row, Col } from 'antd';

const Aboutus = () => {
    return <>
        <Row>
            <Col offset={4} span={16}></Col>
        </Row>
    </>
}

export default Aboutus;